<input name="nb_prod" *ngIf="isServer && isFirstPage" type="hidden" value="{{ nbHits ? nbHits : 0 }}" />
<input
  name="nb_soldprod"
  *ngIf="isServer && isFirstPage && page?.nbProductsSold"
  type="hidden"
  [value]="page.nbProductsSold"
/>

<div class="catalogPage">
  <vc-catalog-action-bar
    class="catalogPage__actionBar"
    *ngIf="config?.withFilters"
    [isMobile]="isMobile"
    [configCatalog]="config"
    [hasSort]="true"
    (change)="actionBarClicked($event)"
  ></vc-catalog-action-bar>

  <vc-catalog-header
    class="catalogPage__header"
    *ngIf="page || campaign"
    [data]="page"
    [campaign]="campaign"
    [breadcrumb]="breadcrumb"
    [isMobile]="isMobile"
  ></vc-catalog-header>

  <div #catalogPage__catalog class="catalogPage__catalog">
    <ais-instantsearch
      #aisInstantSearch
      *ngIf="instantSearchConfig"
      [config]="instantSearchConfig"
      (change)="onSearchChange($event)"
    >
      <vc-catalog-skeleton
        *ngIf="isPending"
        [cardsCount]="12"
        [filtersCount]="6"
        [pageType]="pageType"
      ></vc-catalog-skeleton>
      <div
        class="catalog innerContainer"
        [ngClass]="{
          visuallyhidden: isPending
        }"
      >
        <vc-catalog-state *ngIf="searchParameters" [searchParameters]="searchParameters"></vc-catalog-state>

        <div
          *ngIf="config?.withFilters"
          class="catalog__columnFilters"
          [ngClass]="{
            'catalog__columnFilters--opened': filterMenuIsOpened_onMobile
          }"
        >
          <div class="catalog__colmunFiltersInner">
            <div class="catalog__columnFilters__header d-md-none">
              <ng-container i18n="@@CATALOG.FILTER_BUTTON">Filter by</ng-container>
              <button class="vc-dialog__closeBtn" (click)="closeFilterMenu()">
                <span i18n="@@MODAL.BUTTON.CLOSE" class="vc-dialog__closeBtn__text">Close</span>
                <vc-sprite-icons class="vc-dialog__closeBtn__icon" name="cross-x-thick"></vc-sprite-icons>
              </button>
            </div>

            <div class="catalog__titleFilterBy d-none d-md-block" i18n="@@CATALOG.FILTER_BY">Filter by</div>
            <vc-catalog-filters
              [facets]="facets"
              [applyPriceFilter]="applyPriceFilter"
              [nbHits]="nbHits"
              [refinedFacets]="refinedFacets"
              [page]="page"
              [facetLink]="facetLink"
              [showRefinementBody]="!isMobile"
              [currentCountry]="currentCountry"
              [isMobile]="isMobile"
              (clickedFilter)="trackClickedFilter($event)"
              [userDSeligibility]="isUserDSeligible"
              [catalogContainerOffset]="catalogContainerOffset"
              [marketingFilterLocal]="marketingFilterLocal"
              [currentDeal]="currentDeal"
              [isLogged]="isLogged"
              [personalizationIsApplicable]="isMyFitApplicable"
              [isCampaign]="!!campaign"
            ></vc-catalog-filters>
          </div>
          <div class="catalog__columnFilters__actionBar d-md-none">
            <ais-clear-refinements
              i18n-buttonLabel="@@CATALOG.FILTER.CLEAR_REFINMENT"
              buttonLabel="Clear all filters"
              [excludeAttributes]="[catalogLinksAttribute]"
              class="vc-btn vc-btn--medium catalog__columnFilters__actionBtn catalog__columnFilters__actionBtn--clear"
              (click)="toggleFilterMenu($event, false)"
            ></ais-clear-refinements>
            <button
              class="vc-btn vc-btn--medium vc-btn--primary catalog__columnFilters__actionBtn"
              (click)="toggleFilterMenu($event, true)"
            >
              <ng-container i18n="@@CATALOG.FILTER_BUTTON_APPLY">Apply</ng-container> ({{ nbHits }})
            </button>
          </div>
        </div>

        <div class="catalog__columnProductList">
          <!-- Catalogue refinements -->
          <vc-catalog-widget-current-refinements
            *ngIf="config?.withFilters"
            [attributes]="config.currentRefinementOnly"
            [marketingFilterLocal]="marketingFilterLocal"
            [currentDeal]="currentDeal"
            (refinedCountries)="refinedCountries($event)"
          >
            <vc-alerts [configCatalog]="config" [state]="searchState"></vc-alerts>
          </vc-catalog-widget-current-refinements>

          <div *ngIf="config?.withPagination" class="d-md-flex catalog__sortActionBar">
            <!-- catalog sort -->
            <vc-catalog-sort [isMobile]="isMobile" [sortListOpen]="sortListOpen"></vc-catalog-sort>
            <!-- // end catalog sort -->
            <vc-catalog-widget-pagination
              [ngClass]="{'d-none': !showPagination}"
              [displayText]="false"
              [page]="page"
              *ngIf="!isServer || (page && page.indexation && page.indexation.crawlPagination && isServer)"
            ></vc-catalog-widget-pagination>
          </div>

          <div class="catalog__resultContainer">
            <!-- Desktop catalog product listing -->
            <ais-hits *ngIf="!isMobile">
              <ng-template let-hits="hits" let-results="results">
                <!-- No results message -->
                <div *ngIf="hits && !hits.length">
                  <ng-container i18n="@@CATALOG.NO_RESULTS">No results</ng-container>
                  <strong>&nbsp;{{ results.query }}</strong
                  >.
                </div>
                <ul class="row row--gutter10 row-md--gutter20">
                  <!-- Hit template -->
                  <ng-container *ngFor="let hit of hits; let i = index; trackBy: trackByHit">
                    <li [ngClass]="config.withFilters ? 'col-6 col-lg-4' : 'col-6 col-md-4 col-lg-3'">
                      <vc-catalog-snippet
                        class="catalog__product"
                        [index]="indexCalculator ? indexCalculator + i : i"
                        [likedItem]="likedItem"
                        [product]="productFromAlgoliaHit(hit)"
                        [lazyOff]="isFirstPage"
                        [queryId]="queryID"
                        [indexName]="indexName"
                        (eventManager)="trackProductClick($event)"
                        itemscope
                        itemtype="https://schema.org/Product"
                      ></vc-catalog-snippet>
                    </li>
                    <ng-container *ngIf="showCatalogBreaker && (i + 1 === firstIndexOfNoPerso)">
                      <ng-container *ngTemplateOutlet="catalogBreaker"></ng-container>
                    </ng-container>
                  </ng-container>
                </ul>
              </ng-template>
            </ais-hits>

            <!-- Mobile catalogue product listing -->
            <ais-infinite-hits *ngIf="isMobile">
              <ng-template let-hits="hits" let-results="results" let-showMore="showMore">
                <!-- No results message -->
                <div *ngIf="hits && !hits.length">
                  <ng-container i18n="@@CATALOG.NO_RESULTS">No results</ng-container>
                  <strong>&nbsp;{{ results.query }}</strong
                  >.
                </div>
                <ul class="row row--gutter10 row-md--gutter20">
                  <!-- Hit template -->
                  <ng-container *ngFor="let hit of hits; let i = index; trackBy: trackByHit">
                    <li [ngClass]="config.withFilters ? 'col-6 col-lg-4' : 'col-6 col-md-4 col-lg-3'">
                      <vc-catalog-snippet
                        class="catalog__product"
                        [index]="indexCalculator ? indexCalculator + i : i"
                        [likedItem]="likedItem"
                        [product]="productFromAlgoliaHit(hit)"
                        itemscope
                        (eventManager)="trackProductClick($event)"
                        itemtype="https://schema.org/Product"
                      >
                      </vc-catalog-snippet>
                    </li>
                    <ng-container *ngIf="showCatalogBreaker && (i + 1 === firstIndexOfNoPerso)">
                      <ng-container *ngTemplateOutlet="catalogBreaker"></ng-container>
                    </ng-container>
                  </ng-container>
                </ul>
                <button
                  *ngIf="config?.withPagination && totalPageNumber > 1 && currentPageNumber < totalPageNumber"
                  (click)="showMore()"
                  class="vc-btn vc-btn--primary vc-btn--medium vc-btn--full--sm-down catalog__infiniteLoaderButton"
                  i18n="@@CATALOG.FILTER_BUTTON_LOAD_MORE"
                >
                  View more
                </button>
              </ng-template>
            </ais-infinite-hits>
          </div>

          <div *ngIf="config?.withPagination && !isMobile" class="catalog__pagination__bottom">
            <vc-catalog-widget-hits-per-page></vc-catalog-widget-hits-per-page>
            <vc-catalog-widget-pagination *ngIf="showPagination && !isServer"></vc-catalog-widget-pagination>
          </div>

          <vc-catalog-suggestions
            *ngIf="seoLinks"
            [seoLinks]="seoLinks"
            (clickSeoLink)="trackSeoLinksClick($event)"
          ></vc-catalog-suggestions>

          <vc-catalog-seo-content
            class="tuSelector-seoContent"
            *ngIf="(seoContents?.body || page?.content?.body) && isFirstPage && !isLogged"
            [content]="page?.content?.body ? page.content : seoContents"
            [searchStore]="searchStore"
          ></vc-catalog-seo-content>
        </div>
      </div>
    </ais-instantsearch>
  </div>
</div>

<ng-template #catalogBreaker>
  <li class="catalog__catalogBreaker col-12">
    <div class="catalog__catalogBreaker__title vc-text-xl" i18n="@@PERSO.MORE_ITEM.TITLE">
      More items for your search
    </div>
    <p class="catalog__catalogBreaker__text vc-text-m" i18n="@@PERSO.MORE_ITEM.SUBTITLE">
      These items are not personalized for you but they match the rest of your search
    </p>
  </li>
</ng-template>
